export default __webpack_public_path__ + "static/media/partner-10.2fff0aff.png";